import {Frame} from "types/Frame";
import {dateTime} from "services/date";
import deserializeFile from "services/ngage/deserializers/file";

/**
 * Transform the given frame by deserializing object properties
 *
 * @internal
 * @param frame
 */
export default function deserializeFrame(frame: any): Frame {
    frame.asset = deserializeFile(frame.asset)
    frame.created_at = dateTime(frame.created_at)
    frame.updated_at = dateTime(frame.updated_at)

    return frame;
}